<script lang="ts" setup>
import OmniSelect from "@/components/selects/OmniSelect.vue";
import { TruckStatus, TruckStatusList } from "@/constants/truck";
import { computed } from "vue";

type TruckStatusItem = (typeof TruckStatusList)[number];

const model = defineModel<TruckStatus | TruckStatus[]>();

const props = withDefaults(
  defineProps<{
    rules?: any[];
    required?: boolean;
    disabled?: boolean;
    clearable?: boolean;
    multiple?: boolean;
    forTrip?: boolean;
    statuses?: TruckStatus[];
    label?: string;
    dataQa?: string;
    disabledOptions?: TruckStatus[];
  }>(),
  {
    rules: () => [],
    required: false,
    disabled: false,
    clearable: false,
    multiple: false,
    forTrip: false,
    statuses: undefined,
    label: () => "Truck status",
    dataQa: "truck-status-select-finish",
    disabledOptions: () => [],
  },
);

const emit = defineEmits<{
  (e: "search", value: TruckStatus | TruckStatus[] | undefined): void;
}>();

const items = computed(() => {
  let source: TruckStatusItem[];

  if (props.statuses?.length) {
    source = props.statuses
      .map((id) => TruckStatusList.find((item) => item.id === id))
      .filter((item): item is TruckStatusItem => Boolean(item));
  } else if (props.forTrip) {
    source = TruckStatusList.filter((item) => item.forTrip);
  } else {
    source = TruckStatusList;
  }

  return source.map((item) => {
    const isDisabled = props.disabledOptions.includes(item.id);

    return {
      ...item,
      disabled: isDisabled,
    };
  });
});

const classes = computed(() => {
  return props.required ? "required" : "";
});
</script>

<template>
  <omni-select
    v-model="model"
    :class="classes"
    :clearable="clearable"
    :data-qa="dataQa"
    :disabled="disabled"
    :items="items"
    :label="label"
    :multiple="multiple"
    :required="required"
    :rules="rules"
    @search="(value) => emit('search', value)"
  ></omni-select>
</template>

<style lang="scss" scoped></style>
